import {
  getUser,
  getUserAddresses,
  getUserOrders,
} from "../../services/userService";
import { refreshAccessToken } from "../../store/slice/authSlice";
import { AppDispatch, RootState } from "../../store/store";
import "./Profile.scss";
import AccountSettings from "./components/AccountSettings/AccountSettings";
import AddressCards from "./components/AddressCards/AddressCards";
import LeftPanel from "./components/LeftPanel/LeftPanel";
import OrderList from "./components/OrderList/OrderList";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const Profile = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const { user, addresses, orders } = useSelector(
    (state: RootState) => state.user
  );
  const dispatch = useDispatch<AppDispatch>();
  const params = useMemo(() => new URLSearchParams(search), [search]);
  const activeSection = useMemo(() => Array.from(params.keys())[0], [params]);
  const { access_token } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (access_token && !user?.id) {
      dispatch(getUser(access_token));
    }
  }, [user, access_token, dispatch]);

  useEffect(() => {
    dispatch(refreshAccessToken());
  }, [dispatch]);

  useEffect(() => {
    if (!params.toString()) {
      navigate("?informations", { replace: true });
    }
  }, [params, navigate]);

  useEffect(() => {
    if (activeSection === "informations" && access_token && !user?.id) {
      dispatch(getUser(access_token));
    }
  }, [activeSection, user, access_token, dispatch]);

  useEffect(() => {
    dispatch(getUserAddresses(access_token!));
    dispatch(getUserOrders(access_token!));
  }, [access_token, user, user?.id, dispatch]);

  return (
    <div className="profile-page">
      <LeftPanel activeTab={activeSection} />
      <div>
        {activeSection === "informations" && (
          <AccountSettings userInfo={user} access_token={access_token} />
        )}
        {activeSection === "address" && (
          <AddressCards addressList={addresses} access_token={access_token} />
        )}
        {activeSection === "historique" && <OrderList orders={orders} />}
      </div>
    </div>
  );
};

export default Profile;
